<template>
  <div>
    <v-form ref="formCoureur" v-model="valid">
      <v-checkbox class="checkbox_connaissance mb-1" color="primary-dark" hide-details v-model="accepte_transfert">
        <template v-slot:label>
          <p>Je reconnais que ce transfert est irréversible</p>
        </template>
      </v-checkbox>
      <v-checkbox class="checkbox_connaissance mb-1" color="primary-dark" hide-details v-model="accepte_modalites">
        <template v-slot:label>
          <p>J'accepte les modalités du transfert d'inscription</p>
        </template>
      </v-checkbox>
      <label class="field_label">Email de la personne à qui vous souhaitez transférer votre inscription<span
          class="text-red">*</span></label>
      <v-text-field v-model="mail_recipient" ref="field" @blur="$refs.field.validate()"
        :rules="[$formRules.required, $formRules.email]" />
      <p v-if="mainStore.module.has_limite_transfert_dossard">Le transfert d'inscription est disponible
        jusqu'au {{
          $moment(mainStore.module.metadatas.limite_transfert_dossard).format("DD/MM/YYYY") }}</p>
      <v-alert color="dark-red" variant="tonal" class="mb-2" v-for="(error, index_error) in errors" :key="index_error"
        type="error">
        {{ error }}
      </v-alert>
      <div v-if="!onload">
        <v-btn v-if="(!accepte_transfert || !accepte_modalites)" color="primary-dark" class="sm-fullwidth cursor_lock"
          variant="outlined">
          <v-icon icon="mdi-arrow-right-bold"></v-icon> Transférer mon inscription
          <v-tooltip activator="parent" location="top">Vous devez accepter les modalités de transfert
            d'inscription</v-tooltip>
        </v-btn>
        <v-btn v-else class="sm-fullwidth" variant="outlined" color="primary-dark" @click="validate"
          :disabled="!accepte_transfert || !accepte_modalites"><v-icon icon="mdi-arrow-right-bold"></v-icon>
          Transférer mon
          inscription</v-btn>



      </div>
    </v-form>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
export default {
  props: {
    admin: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      accepte_transfert: false,
      accepte_modalites: false,
      mail_recipient: "",
      errors: [],
      valid: false,
      onload: false,
    };
  },
  computed: {
    ...mapStores(useMainStore),
  },
  methods: {
    async validate() {
      this.onload = true;
      this.errors = [];
      let res = await this.$refs.formCoureur.validate();
      if (res.valid) {
        this.$emit("onSuccess", this.mail_recipient);
      } else {
        this.errors.push("Certains champs nécessitent votre attention, merci de les vérifier avant de continuer.");
      }
    },
  },

  async created() { },
};
</script>

<style lang="scss" scoped></style>